// client/src/utils/site.js
// 站点模式识别: 与 Nginx server_name 分流及后端 X-Site-Mode 头三方对应。
//   kehu.eazyapi.vip   → EA 客户专用域名(页面层不开放, 仅 /api/)
//   daili.eazyapi.vip  → 代理后台(只收普通/VIP 用户, 超管被后端拦)
//   taishan.eazyapi.vip/主域 → 超管后台(只收超管)
// 本地开发/直连 IP 访问时回落 taishan, 不影响调试。
export const getSiteMode = () => {
  if (typeof window === 'undefined') return 'taishan';
  const host = window.location.hostname.toLowerCase();
  if (host.startsWith('kehu.')) return 'kehu';
  if (host.startsWith('daili.')) return 'daili';
  return 'taishan';
};

// 登录页副标题: 按站点告诉用户这是什么入口
export const getLoginSubtitle = (mode) => {
  if (mode === 'daili') return '登录代理商账户';
  return '登录超级管理员账户';
};
